module.exports = __webpack_public_path__ + "static/20260827_Investor_Call_Dial-in_Information-34ca4aca95aa7f275a1b77b08f34fca1.pdf";